var $advancedSearchFilters = $('.insights-search__advanced-wrapper');
var $trigger = $('.insights-search__advanced-btn');

if (!$advancedSearchFilters) return;

$trigger.click(function() {
  if($advancedSearchFilters.css('display') == "none") {
      $trigger.addClass('is-active');
      $advancedSearchFilters.slideDown({ duration: 500 });
  }
  else {
      $trigger.removeClass('is-active');
      $advancedSearchFilters.slideUp({ duration: 500 });
  }
});

